import angular from 'angular';

import TabContentComponent from './components/tab-content/tab-content-component';
import TabHeaderComponent from './components/tab-header/tab-header-component';

export default angular
  .module('email-notifications-tab', [])
  .component('emailNotificationsTabHeader', new TabHeaderComponent())
  .component('emailNotificationsTabContent', new TabContentComponent());



// WEBPACK FOOTER //
// ./src/modules/email-notification-templates/components/email-notification-tab/email-notification-tab-component.js